export default "__VITE_ASSET__CwDRonbg__"